import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1063.68,251 L1063.68,533.33 L714.24,533.33 C476.16,533.33 282.24,725.39 282.24,959.705 C282.24,1194.02 474.24,1386.08 712.32,1386.08 L712.32,1386.08 L1061.76,1386.08 L1061.76,1668.41 L712.32,1668.41 C320.64,1668.41 0,1351.505 0,959.705 C0,567.90125 320.64,251 712.32,251 L712.32,251 L1063.68,251 Z M1345.92,452.6675 L1920,959.705 L1920,959.7125 L1345.92,1466.7425 L1345.92,1128.7175 L741.12,1128.7175 C647.04,1128.7175 572.16,1053.815 572.16,959.705 C572.16,865.595 647.04,790.6925 741.12,790.6925 L741.12,790.6925 L1345.92,790.6925 L1345.92,452.6675 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCommonsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCommonsSolid, _Component);

  var _super = _createSuper(IconCommonsSolid);

  function IconCommonsSolid() {
    _classCallCheck(this, IconCommonsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCommonsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCommons",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCommonsSolid.displayName = "IconCommonsSolid";
  return IconCommonsSolid;
}(Component);

IconCommonsSolid.glyphName = 'commons';
IconCommonsSolid.variant = 'Solid';
IconCommonsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCommonsSolid;
export { IconCommonsSolid };